import { SvgIcon } from "@mui/material";
import React from "react";


function RainIcon(props) {
    return (
      <SvgIcon {...props}>
        <g transform="translate(0.000000,1058.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
            <path d="M4650 10569 c-937 -70 -1724 -444 -1965 -934 -63 -129 -79 -198 -79
            -335 1 -173 44 -305 151 -455 l50 -69 -206 -42 c-796 -160 -1448 -506 -1942
            -1029 -533 -565 -761 -1317 -614 -2025 71 -342 239 -691 479 -995 99 -125 319
            -345 451 -450 535 -428 1211 -698 1980 -792 214 -25 767 -26 975 0 309 39 595
            101 850 186 l145 49 112 -75 c398 -263 898 -438 1448 -505 147 -17 702 -18
            845 0 439 54 811 162 1153 334 348 174 599 371 843 662 l40 49 84 -32 c182
            -69 425 -128 670 -163 62 -8 192 -13 370 -12 297 0 411 12 663 69 493 110 953
            367 1244 695 248 279 382 591 400 926 21 407 -141 797 -467 1124 -171 172
            -359 306 -593 421 -74 37 -87 47 -83 64 3 11 11 90 18 176 38 514 -107 1044
            -412 1501 -121 182 -201 279 -360 438 -530 531 -1271 877 -2090 975 -181 22
            -597 31 -775 16 -368 -30 -711 -104 -1029 -220 l-136 -49 -88 55 c-526 332
            -1339 500 -2132 442z"/>
            <path d="M9613 3370 c-47 -44 -139 -123 -204 -175 -286 -232 -382 -389 -382
            -625 0 -109 21 -178 78 -253 39 -51 139 -122 193 -137 60 -16 300 -13 362 6
            73 22 150 95 195 188 66 135 67 262 5 572 -16 83 -39 212 -49 287 -11 75 -27
            150 -36 166 -15 29 -42 51 -64 51 -6 0 -50 -36 -98 -80z"/>
            <path d="M3136 3201 c-46 -43 -139 -123 -207 -178 -271 -218 -362 -356 -385
            -583 -18 -178 72 -336 233 -412 l63 -30 167 4 c149 3 172 6 208 25 85 46 165
            152 196 263 24 86 15 257 -25 455 -19 99 -44 242 -55 317 -11 75 -27 151 -36
            167 -15 30 -42 51 -65 51 -6 0 -48 -35 -94 -79z"/>
            <path d="M7932 2907 c-48 -46 -143 -128 -212 -184 -251 -201 -339 -329 -372
            -538 -14 -90 -2 -185 33 -260 29 -63 119 -154 182 -184 70 -34 194 -47 317
            -33 112 12 158 30 212 84 143 143 165 314 88 691 -15 78 -38 207 -50 287 -12
            79 -26 153 -32 165 -13 25 -48 54 -66 55 -8 0 -53 -37 -100 -83z"/>
            <path d="M4773 2916 c-15 -12 -53 -46 -83 -75 -30 -29 -111 -98 -180 -154
            -214 -173 -302 -276 -358 -425 -23 -59 -26 -82 -27 -197 0 -124 1 -133 29
            -190 39 -79 111 -149 191 -187 56 -26 81 -31 168 -35 116 -6 232 9 285 36 68
            35 134 118 173 216 20 53 23 76 23 200 -1 121 -6 164 -37 316 -20 97 -43 228
            -52 290 -19 141 -30 182 -52 201 -31 26 -50 27 -80 4z"/>
            <path d="M6410 2792 c-8 -3 -52 -40 -97 -82 -45 -43 -135 -120 -200 -172 -208
            -168 -298 -277 -350 -425 -24 -67 -27 -94 -28 -193 0 -108 2 -119 31 -180 39
            -82 108 -151 193 -193 65 -32 66 -32 221 -32 140 1 160 3 207 24 99 44 188
            164 214 291 18 87 6 273 -30 442 -16 81 -40 211 -51 290 -11 78 -28 158 -38
            177 -19 39 -50 61 -72 53z"/>
            <path d="M8778 1462 c-51 -48 -138 -123 -193 -167 -259 -204 -365 -366 -382
            -585 -13 -175 64 -317 221 -402 l61 -33 165 0 c147 0 170 2 211 21 59 28 110
            73 149 134 84 131 94 291 36 585 -20 99 -45 241 -55 316 -23 154 -26 165 -54
            197 -36 39 -60 29 -159 -66z"/>
            <path d="M3616 1291 c-46 -43 -139 -123 -207 -178 -262 -212 -352 -344 -378
            -551 -24 -194 54 -351 220 -438 53 -28 57 -29 219 -29 206 0 233 9 318 100
            128 137 149 301 81 640 -16 83 -41 221 -54 308 -14 88 -28 164 -31 170 -16 29
            -49 57 -66 57 -10 0 -56 -35 -102 -79z"/>
            <path d="M7084 1224 c-43 -41 -110 -101 -149 -132 -310 -250 -390 -353 -431
            -551 -44 -222 33 -399 215 -488 51 -26 67 -28 193 -31 161 -4 231 8 287 48 55
            40 115 119 143 187 21 53 23 73 23 218 -1 141 -5 178 -33 314 -18 84 -42 217
            -53 294 -22 147 -36 189 -68 207 -34 18 -46 12 -127 -66z"/>
            <path d="M5369 1209 c-41 -39 -130 -117 -199 -172 -283 -228 -370 -359 -395
            -592 -8 -75 15 -191 49 -249 35 -59 117 -133 184 -164 54 -26 64 -27 217 -27
            146 0 165 3 212 24 106 47 193 177 213 321 15 100 6 195 -40 435 -21 110 -44
            242 -50 293 -15 118 -24 149 -52 179 -35 37 -59 29 -139 -48z"/>
            </g>
      </SvgIcon>
    );
  }

export default RainIcon;